import axios from "axios";
import ObjectUtil from "../../../../utils/common/ObjectUtil";
import {ordersServicesPath} from "../../../../Constants";

const orderRestUrl = ordersServicesPath + '/organizations/orders'
const orderCustomerRestUrl = ordersServicesPath + '/customers/orders'

export default class OrderService {

    static async getOrders() {
        return axios.get(orderRestUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersByCloud() {
        return axios.get(orderRestUrl + '/by-cloud', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersByComposition() {
        return axios.get(orderRestUrl + '/by-composition', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getByIdForFulComposition(id) {
        return axios.get(`${orderRestUrl}/${id}/for-ful-composition`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersByCloudArchive() {
        return axios.get(orderRestUrl + '/by-cloud-archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersByEconomic(startShipped, finishShipped, startReceipt, endReceipt, startManufactured, endManufactured) {
        const params = {
            startShipped: startShipped,
            endShipped: finishShipped,
            startReceipt: startReceipt,
            endReceipt: endReceipt,
            startManufactured: startManufactured,
            endManufactured: endManufactured
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        return axios.get(`${orderRestUrl}/by-economic?${queryString}`)
    }

    static async downloadByEconomic(startShipped, finishShipped, startReceipt, endReceipt, startManufactured, endManufactured) {
        const params = {
            startShipped: startShipped,
            endShipped: finishShipped,
            startReceipt: startReceipt,
            endReceipt: endReceipt,
            startManufactured: startManufactured,
            endManufactured: endManufactured
        };
        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        return axios.get(`${orderRestUrl}/by-economic/download?${queryString}`, {
            responseType: 'blob'
        });
    }

    static async getByEconomicPlan() {
        return axios.get(orderRestUrl + "/by-economic-plan", {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getByEconomicNotConstructed() {
        return axios.get(orderRestUrl + "/by-not-constructed", {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersForWriteOff() {
        return axios.get(orderRestUrl + "/for-write-off", {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersArchive() {
        return axios.get(orderRestUrl + '/archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersNotImplemented() {
        return axios.get(orderRestUrl + '/not-implemented', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersProduction() {
        return axios.get(orderRestUrl + '/production', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async getOrdersProductionShipped() {
        return axios.get(orderRestUrl + '/production-shipped', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersProductionByPlanId(planId) {
        return axios.get(orderRestUrl + '/production/plan' + "?planId=" + planId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersConstructors() {
        return axios.get(orderRestUrl + '/constructors', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrdersConstructorsDone() {
        return axios.get(orderRestUrl + '/constructors-done', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async getOrdersPlanning() {
        return axios.get(orderRestUrl + '/for-planning', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data, customerId, customerName, modelHeaderId, attributeId, orderType) {
        return await axios.post(orderRestUrl + "?customerId=" + customerId + '&modelHeaderId=' + modelHeaderId +
            '&attributeId=' + attributeId + '&customerName=' + customerName + "&orderType=" + orderType, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async copy(id) {
        return await axios.post(orderRestUrl + "/" + id, JSON.stringify({}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(data, modelHeaderId) {
        return await axios.put(orderRestUrl + '/' + data.id
            + '?modelHeaderId=' + modelHeaderId,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(orderRestUrl + '/' + +id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async sendToArchive(id) {
        return await axios.patch(orderRestUrl + '/' + id + '/send-to-archive',
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async updateConstructor(data, constructorId, technologistId) {
        return await axios.post(orderRestUrl + '/' + data.id + '/constructor'
            + "?constructorId=" + constructorId
            + '&technologistId=' + technologistId,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async setModelById(idOrder, idModel) {
        return await axios.post(orderRestUrl + '/' + idOrder + '/set-model-by-id'
            + "?idModel=" + idModel,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async deleteModelById(idOrder) {
        return await axios.post(orderRestUrl + '/' + idOrder + '/delete-model-by-id',
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async unableAttributeByOrderId(id, attributeId, status) {
        return axios.patch(orderRestUrl + '/' + id + '/unable-attribute' + '?attributeId=' + attributeId + '&status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setPlanByIds(ids, planId) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        await axios.patch(orderRestUrl + '/set-plan-by-ids'
            + '?planId=' + planId,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async deletePlanByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        await axios.patch(orderRestUrl + '/delete-by-ids', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllIssuingEdges() {
        return axios.get(orderRestUrl + '/issuing-edges', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByIssuingEdgesId(issuingEdgesId) {
        return axios.get(orderRestUrl + '/issuing-edges/' + issuingEdgesId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addModel(orderId, modelId) {
        return await axios.post(orderRestUrl + '/' + orderId + '/add-model'
            + "?modelId=" + modelId,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async getAllCustomerOOrdersProduction() {
        return axios.get(orderCustomerRestUrl + '/production', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllCustomerOrderProductionShipped() {
        return axios.get(orderCustomerRestUrl + '/production-shipped', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}